import { filter, get, values } from 'lodash'
import { createSelector } from 'reselect'

export const getAllPayments = state => {
  return values(get(state, 'customerPayment.byId'))
}

const getCustomerPayments = (state, customerId) => {
  const allPayments = getAllPayments(state)
  const customerPaymentIds = get(state, `customerPayment.byCustomerId.${customerId}`, [])
  const customerPayments = filter(allPayments, (payment) => customerPaymentIds.includes(payment.uuid))

  return customerPayments

}

export const makeGetCustomerPayments = () => createSelector(
  [getCustomerPayments],
  (payments) => payments
)

export const getIsPaymentLoading = state => state?.customerPayment?.isLoading ?? false
